export default __webpack_public_path__ + "static/media/TrustPlus_MobileImg.44f60081.png";